import { render } from "./AgentDocuments.vue?vue&type=template&id=4883d33a&scoped=true"
import script from "./AgentDocuments.vue?vue&type=script&lang=js"
export * from "./AgentDocuments.vue?vue&type=script&lang=js"

import "./AgentDocuments.vue?vue&type=style&index=0&id=4883d33a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4883d33a"]])

export default __exports__